import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BehaviorSubject } from 'rxjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ApiUrl } from './app/shared/utilities/api-config';

const lowLevelOffline = new BehaviorSubject<boolean>(true);
window['lowLevelOffline'] = lowLevelOffline;

async function init() {
  await pingTest();
  setInterval(pingTest, 10000);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

init();

function online() {
  if (!lowLevelOffline.getValue()) {
    lowLevelOffline.next(true);
  }
}

function offline() {
  if (lowLevelOffline.getValue()) {
    lowLevelOffline.next(false);
  }
}

async function pingTest() {
  if (navigator.onLine) {
    try {
      const pingResponse = await fetch(`${ApiUrl}user/Ping`);
      const responseText = await pingResponse.text();
      if (responseText === 'success') {
        online();
      } else {
        offline();
      }
    } catch (error) {
      lowLevelOffline.next(false);
    }
  } else {
    offline();
  }
}


window.addEventListener('load', function () {
  window.addEventListener('offline', offline);
  window.addEventListener('online', online);
});
